module.exports = __webpack_public_path__ + "img/viewed-document.5f385167.svg";